// NPM Imports
import React, { Component, lazy, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../revvComponents";
// import { ICellRendererParams } from "ag-grid-community";

import { AssetActions, FieldsSetting } from "../../../actions";
import { FIELDS } from "../../../constants";

// Component Imports
import FieldsDataHeader from "./FieldsDataHeader";
import DateFilterPopup from "../FieldMapping/DateFilterPopup";
import CreateDocumentPopup from "./CreateDocumentWithData";
import { formatFieldData } from "../../../actions/FieldsSetting/fieldsSettingMethod";
import FieldTableData from "./FieldTableData";
import { GlobalUtils } from "../../../utils";
import FieldDataDetails from "./FieldDataDetails";

const { DATA_SOURCES, DATA_STUDIO_VIEW } = FIELDS;
const { getAssetFolderTreeAction } = AssetActions;
const {
  fetchTransformedData,
  updateDataStdioView,
  nukeSyncDataSourceFlags,
  toggleFieldRowSelection,
  startSyncingDataSource,
  nukeAllRowsSelected,
  updateDataSourceSelected,
  setFlagForAgrgrid,
  updateDataStudioMappedView,
  resetCurrentSelectedObject,
} = FieldsSetting;

// Component Dynamic Imports
const AgGridWrapper = lazy(() =>
  import(/* webpackChunkName: "ag-grid-wrapper" */ "../../AgGridWrapper"),
);

class FieldsData extends Component {
  state = {
    showCreateDocumentPopup: false,
    showDateFilter: false,
    // frameworkComponents: {
    //   FieldTableData,
    // },
  };

  // Callback on ag-grid ready state
  _onGridReady = api => {
    // Resize columns after it's completly loaded
    // gridApi = api;
    GlobalUtils.saveGridAPi(api);
    api.api.sizeColumnsToFit();

    // add id to each rowHeight
    let idSequence = 0;
    api.api.forEachNode(rowNode => {
      rowNode.id = idSequence;
      idSequence += 1;
    });
  };

  _togglePopUp = (type, flag, value) => {
    let data;
    if (value !== undefined) {
      data = {
        type: flag,
        rowindex: value.rowIndex,
        colId: value.colId,
      };
    } else {
      data = {
        type: flag,
      };
    }

    this.props.setFlagForAgrgrid(data);
    if (!flag) {
      FieldsData.rowData = null;
    }
  };

  // _getContextMenuItems = params => {
  //   const contextMenuItems = [
  //     "autoSizeAll",
  //     {
  //       name: "Reset Columns",
  //       action: () => gridApi.api.sizeColumnsToFit(),
  //     },
  //     "copy",
  //     "export",
  //   ];
  // if (params.column.colDef.type === "Table") {
  //   contextMenuItems.unshift({
  //     name: "Show table",
  //     action: () => {
  //       FieldsData.rowIndex = params.node.rowIndex;
  //       FieldsData.colId = params.column.colId;
  //       FieldsData.colData = params.column.colDef;
  //       FieldsData.value = params.value;
  //       FieldsData.rowData = params.node.data;
  //       const value = {
  //         rowIndex: FieldsData.rowIndex,
  //         colId: FieldsData.colId,
  //       };
  //       this._togglePopUp("showTableData", true, value);
  //     },
  //   });
  // }
  //   return contextMenuItems;
  // };

  // onCallAllCells = () => {
  //   // no params, goes through all rows and columns where cell renderer exists
  //   const instances = gridOptions.api.getCellRendererInstances();
  //   instances.forEach(instance => {
  //     instance.medalUserFunction();
  //   });
  // };

  _changeDataStudioView = view => {
    this.props.nukeAllRowsSelected();
    this.props.updateDataStdioView(view);
  };

  _changeDataSource = () => {
    this.props.nukeSyncDataSourceFlags();
    this.props.updateDataStudioMappedView("CONFIG_VIEW");
    this.props.updateDataStdioView("CONFIG_VIEW");

    this.props.updateDataSourceSelected("");
    this.props.resetCurrentSelectedObject();
  };

  _handleDateFilterPopup = () => {
    if (this.props.dataSourceSelected === "csv") {
      this._handleStartSync();
    } else {
      this.setState({ showDateFilter: true });
    }
  };

  _handleStartSync = (startDate, EndDate) => {
    const { dataSource, objectName, csvFileHash, templateID } =
      this.props.syncDataSource;
    let objName = objectName;
    if (this.props.dataSourceSelected === "csv") {
      startDate = "";
      EndDate = "";
      if (csvFileHash) {
        objName = csvFileHash;
      }
    }
    // const { currentSelectedObject, dataSourceSelected } = this.props;
    this.props.startSyncingDataSource(
      dataSource,
      objName,
      startDate,
      EndDate,
      templateID,
    );
    this.setState({ showDateFilter: false });
  };

  _closePopup = () => {
    this.setState({ showDateFilter: false });
  };

  _toggleCreateDocumentPopup = flag => {
    this.setState({ showCreateDocumentPopup: flag });
  };

  _loadMoreFormData = () => {
    const {
      currentPageNum,
      dataSource,
      objectName,
      startDate,
      endDate,
      fileName,
      templateID,
    } = this.props.syncDataSource;
    const isLoadMore = true;
    this.props.fetchTransformedData(
      dataSource,
      objectName,
      startDate,
      endDate,
      fileName,
      templateID,
      currentPageNum + 1,
      isLoadMore,
    );
  };

  _openCreateDocumentPopup = () => {
    this.props
      .getAssetFolderTreeAction()
      .then(() => {
        console.debug("Success");
      })
      .catch(error => {
        console.debug(
          `Asset => getAssetFolderTree => _onInitAssets => Error : ${error}`,
        );
      });
    this._toggleCreateDocumentPopup(true);
  };

  _closeCreateDocumentPopup = () => {
    this._toggleCreateDocumentPopup(false);
  };

  _onRowSelection = rowId => {
    this.props.toggleFieldRowSelection(rowId);
  };

  render() {
    const { fieldData } = this.props;
    let { startDate, endDate } = this.props.syncDataSource;
    if (startDate) {
      const currentStartDate = new Date(startDate).toString();
      startDate = currentStartDate.split(" ").slice(1, 4).join(" ");
    }
    if (endDate) {
      const currentEndDate = new Date(endDate).toString();
      endDate = currentEndDate.split(" ").slice(1, 4).join(" ");
    }

    const { loadMore } = this.props.syncDataSource;
    const source = DATA_SOURCES.find(
      ds => ds.name === this.props.dataSourceSelected,
    );
    return (
      <Fragment>
        {this.state.showCreateDocumentPopup && (
          <CreateDocumentPopup closePopup={this._closeCreateDocumentPopup} />
        )}
        {this.state.showDateFilter && (
          <DateFilterPopup
            closePopup={this._closePopup}
            startDataSync={this._handleStartSync}
            startDate={startDate}
            endDate={endDate}
          />
        )}
        <div className="fields-details-container">
          <section className="fields-header">
            <FieldsDataHeader
              openCreateDocumentPopup={this._openCreateDocumentPopup}
              closePopup={this._closeCreateDocumentPopup}
              syncDataSource={this.props.syncDataSource}
              startSyncingDataSource={this.props.startSyncingDataSource}
              dataSourceSelected={this.props.dataSourceSelected}
              handleDateFilterPopup={this._handleDateFilterPopup}
            />
          </section>
          <section className="datafield-actions">
            <div className="datafield-action-row">
              <Button
                className="btn btn-transparent"
                data-test="data-studio-change-config-submit-btn"
                onClick={() =>
                  this._changeDataStudioView(DATA_STUDIO_VIEW.CONFIG_VIEW)
                }>
                <span>
                  <FontAwesomeIcon icon={["far", "cog"]} />
                </span>{" "}
                Data studio config
              </Button>
              {/* <div
              data-test="create-document-from-datasource"
              className="datafield-action-item"
              role="button"
              tabIndex={0}
              onClick={() => this._changeDataStudioView(DATA_STUDIO_VIEW.CONFIG_VIEW)}
              onKeyDown={() => {}}>
              <span>
                <FontAwesomeIcon icon={["far", "cog"]} />
              </span>{" "}
              Data studio config
            </div> */}
              <Button
                className="btn btn-transparent"
                data-test="data-studio-change-config-submit-btn"
                onClick={this._handleDateFilterPopup}>
                <span>
                  <FontAwesomeIcon icon={["fal", "sync"]} />
                </span>{" "}
                {`Sync from ${source.label}`}
              </Button>
              {/* <div
              data-test="create-document-from-datasource"
              className="datafield-action-item"
              role="button"
              tabIndex={0}
              onClick={() => this._changeDataStudioView(DATA_STUDIO_VIEW.CONFIG_VIEW)}
              onKeyDown={() => {}}>
              <span>
                <FontAwesomeIcon icon={["fal", "sync"]} />
              </span>{" "}
              Sync from salesforce
            </div> */}
              <Button
                className="btn btn-transparent"
                data-test="data-studio-change-config-submit-btn"
                onClick={() => this._changeDataSource("")}>
                <span>
                  <FontAwesomeIcon icon={["fal", "database"]} />
                </span>{" "}
                Select data source
              </Button>
              {/* <div
              data-test="create-document-from-datasource"
              className="datafield-action-item"
              role="button"
              tabIndex={0}
              onClick={() => this._changeDataStudioView(DATA_STUDIO_VIEW.CONFIG_VIEW)}
              onKeyDown={() => {}}>
              <span>
                <FontAwesomeIcon icon={["fal", "database"]} />
              </span>{" "}
              Select data source
            </div> */}
            </div>
          </section>
          {this.props.aggridValue && this.props.aggridValue.showTableData && (
            <section>
              <FieldTableData
                colId={this.props.aggridValue.colId}
                onClose={() => this._togglePopUp("showTableData", false)}
                rowindex={this.props.aggridValue.rowindex}
              />
            </section>
          )}

          <section className="ag-theme-balham fields-listing-section">
            {/* Table Header */}
            <AgGridWrapper
              // Grid Data
              columnData={this.props.playFieldColumnDefs}
              rowData={this.props.fieldData}
              onGridReady={this._onGridReady}
              getRowNodeId={data => data.index + 10}
              rowHeight={34}
              rowSelection="multiple"
              suppressRowClickSelection
              onRowSelected={e => this._onRowSelection(e.rowIndex)}
              suppressScrollOnNewData
              rowMultiSelectWithClick
              getContextMenuItems={this._getContextMenuItems}
              cellMouseOver={this._onMouseOver}
              frameworkComponents={{
                FieldDataDetails,
              }}
              // frameworkComponents={this.state.frameworkComponents}
            />
          </section>
          {loadMore && (
            <section className="fields-data-loadmore">
              <span>{`Rows synced:${fieldData ? fieldData.length : ""}`}</span>{" "}
              <span
                data-test="prev-datafield-values"
                className="prev-datafield-values-btn"
                onClick={this._loadMoreFormData}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                Load more
              </span>
            </section>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    revvFieldDefs,
    transformedData,
    fieldsList,
    playFieldColumnDefs,
    syncDataSource,
    dataSourceSelected,
    tableIdsList,
    aggridValue,
    csvFileHash,
  } = state.FieldsSettingStore;

  const formattedData = formatFieldData(
    transformedData,
    revvFieldDefs,
    tableIdsList,
  );

  return {
    fieldData: formattedData,
    fieldsList,
    playFieldColumnDefs,
    syncDataSource,
    dataSourceSelected,
    aggridValue,
    csvFileHash,
  };
};

const mapDispatchToProps = {
  updateDataStdioView,
  nukeSyncDataSourceFlags,
  fetchTransformedData,
  getAssetFolderTreeAction,
  toggleFieldRowSelection,
  startSyncingDataSource,
  nukeAllRowsSelected,
  updateDataSourceSelected,
  setFlagForAgrgrid,
  updateDataStudioMappedView,
  resetCurrentSelectedObject,
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsData);
